import React                      from 'react'
import { Observer }               from 'mobx-react'

import { TEXT }                   from '../00_assets'
import { FormElement
       , FIELD_TYPE
       , form_model
       , IFormEditor
       , IFormEditorModel
       , SelectMachine
       , VALID }                  from '../10_ui'


export function create_bulk_jobs_editor_model ( )
{
  const fields =
    { machine  : { label: TEXT.KEY_MASTERING_NAME
                 , init: ''
                 , type: FIELD_TYPE.CUSTOM
                 , is_valid: VALID.non_empty_txt
                 , required: true
                 }
    } ;

  return form_model( fields
                   , ( data: IFormEditorModel ) =>
                      ({ machine: { id: parseInt( data.machine.value( ), 10 ) } })
                   ) ;
}


export const BulkJobsEditor: React.FC< { form: IFormEditor } > = ({ form }) =>
<Observer render={ ( ) => 
{ 
  const do_nothing = ( ev: React.FormEvent<HTMLFormElement> ) =>
     {
       ev.preventDefault( ) ;
       ev.stopPropagation( ) ;
     } ;

  return <form onSubmit={ do_nothing }>
           <FormElement
             label={ TEXT.MACHINE_NAME }
           >
             <SelectMachine { ...form.model.machine.bind( ) } />
           </FormElement>
         </form> ;
} } />